import React from 'react'
import _cx from 'classnames/bind'
import cls from './index.scss'
const cx = _cx.bind(cls)

const SparkOfferInterstitial = () => (
  <div
    className={cx('real-auction')}
    data-elm-id='spark_offer_Modal_interstitial'
  >
    You will be taken to the{' '}
    <b>
      <i>SparkOffer</i>
    </b>{' '}
    website for this property where you will be able to:
    <ul className={cx('real-auction-list')}>
      <li>
        <b>Register</b> for a new account.
      </li>
      <li>
        <b>Make an Offer</b> on the property.
      </li>
    </ul>
  </div>
)

export default SparkOfferInterstitial
